// extracted by mini-css-extract-plugin
module.exports = {"email":"emailBtn__email__L1lEg","iconEmail":"emailBtn__iconEmail__8QtcG"};